var Packages = {
    chat: {
        Starter: 'Professional',
        Professional: 'Sales',
        Unlimited: 'Teams',
    },
    ascend: {
        Basic: 'fc002183-deaa-48b5-994c-de613a095c14',
        Professional: '3c7e283f-dff4-4407-b678-00a28e4becb9',
        Unlimited: 'b8772926-1d84-4694-9c4b-3fa583b45403',
    },
};
export var Features = {
    RemoveBranding: 'remove_ascend_branding',
    ScheduledHours: 'scheduled_chat_hours',
    CustomizableChatbox: 'chat_profile_picture',
};
var chatPackages = Object.keys(Packages.chat).map(function (k) { return Packages.chat[k]; });
var highestChatPackage = chatPackages[chatPackages.length - 1];
var ascendPackages = Object.keys(Packages.ascend).map(function (k) { return Packages.ascend[k]; });
var highestAscendPackage = ascendPackages[ascendPackages.length - 1];
export var isHighestTier = function (vendorProductId, ascendVendorProductId) {
    var isHighestChatPackage = highestChatPackage === vendorProductId;
    var isHighestAscendPackage = highestAscendPackage === ascendVendorProductId;
    return isHighestChatPackage || isHighestAscendPackage;
};
export var isPremium = function (vendorProductId, ascendVendorProductId) {
    var isChatPremium = vendorProductId ? chatPackages.indexOf(vendorProductId) !== -1 : false;
    var isAscendPremium = ascendVendorProductId ? ascendPackages.indexOf(ascendVendorProductId) !== -1 : false;
    return isChatPremium || isAscendPremium;
};
//# sourceMappingURL=index.js.map